import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import DeleteButton from './DeleteButton';

// Footer actions for create/edit forms (CP-8412, CP-8423), right-aligned:
//   [leadingActions] [DELETE] [CANCEL] [extraActions] [CREATE | SAVE]
// CREATE has no icon (new record); SAVE keeps the save icon (existing record).
// DELETE is the shared DeleteButton (outlined red + trash, CP-5545): `deletePerm` ('scope.action') disables it,
// not hides it, for a user without the permission. CANCEL is outlined primary.
// The primary button renders only with an onSubmit (e.g. a selection bar with just DELETE + CANCEL),
// and submitVariant="outlined" demotes it where another button is the page's main action.
const FormActionButtons = ({
    mode = 'create',
    onSubmit,
    onCancel,
    onDelete,
    submitDisabled = false,
    cancelDisabled = false,
    deleteDisabled = false,
    deletePerm,
    deleteRef,
    submitRef,
    submitLabel,
    submitIcon,
    submitEndIcon,
    submitType,
    submitVariant = 'contained',
    cancelLabel = 'Cancel',
    cancelIcon,
    deleteLabel = 'Delete',
    leadingActions,
    extraActions,
    size = 'small',
    sx,
}) => {
    const isCreate = mode === 'create';
    const defaultIcon = isCreate ? null : <SaveIcon />;
    return (
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end" gap={1} flexWrap="wrap" sx={sx}>
            {leadingActions}
            {onDelete ? (
                <DeleteButton ref={deleteRef} size={size} onClick={onDelete} disabled={deleteDisabled} perm={deletePerm}>
                    {deleteLabel}
                </DeleteButton>
            ) : null}
            {onCancel ? (
                <Button variant="outlined" color="primary" size={size} onClick={onCancel} disabled={cancelDisabled} startIcon={cancelIcon}>
                    {cancelLabel}
                </Button>
            ) : null}
            {extraActions}
            {onSubmit ? (
                <Button
                    variant={submitVariant}
                    color="primary"
                    size={size}
                    ref={submitRef}
                    type={submitType}
                    onClick={onSubmit}
                    disabled={submitDisabled}
                    startIcon={submitIcon === undefined ? defaultIcon : submitIcon}
                    endIcon={submitEndIcon}
                >
                    {submitLabel || (isCreate ? 'Create' : 'Save')}
                </Button>
            ) : null}
        </Box>
    );
};

export default FormActionButtons;
